

let horaSeleccionada = null;

export function getHoraSeleccionada() {
    return horaSeleccionada;
}

export function setHoraSeleccionada(hora) {
    horaSeleccionada = hora;
}

export function seleccionarHora(btn, hora) {
    document.querySelectorAll('.hora-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    setHoraSeleccionada(hora);
}